<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div>
    <vs-sidebar click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
      <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentNotice">
        <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
              <h4 v-if="currentNotice.title">{{ currentNotice.title }}</h4>
            </div>
          </div>
          <div class="ml-10 mb-4 mt-1">
            <div class="email__actions--single flex items-baseline">
              <feather-icon icon="EditIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" v-if="activeSpaceInfo.service == true && activeUserInfo.uid == currentNotice.user_id " @click="editStudentNotice()"></feather-icon>
              <feather-icon icon="TrashIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" v-if="activeSpaceInfo.service == true && activeUserInfo.uid == currentNotice.user_id" @click="deleteStudentNotice()"></feather-icon>
              <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousMail')" />
              <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('nextMail')" />
            </div>
          </div>
        </div>
        <component :is="scrollbarTag" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
          <div v-if="isSidebarActive">
            <!-- LATEST MESSAGE -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <vx-card class="px-4" >
                  <!-- MAIL HEAD -->
                  <div class="vx-row">
                    <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                      <!-- Sender Details -->
                      <div class="flex items-center">
                        <div class="flex flex-col">
                          <!-- <vs-chip v-if="currentNotice.service" color="#28c76f" style="width:100%; height:20px; margin-right:10px;">on</vs-chip>
                          <vs-chip v-if="!currentNotice.service" color="#d5d5d5" style="margin-right:10px;">off</vs-chip>                           -->
                        </div>
                      </div>
                      <!-- /Sender Details -->
                      <!-- Mail Time & Date -->
                      <div class="flex flex-col justify-end">
                        <span class="text-right">{{ currentNotice.update_time | time }}</span>
                        <div class="flex justify-end mt-2">
                          <span class="text-right">{{ currentNotice.update_time | date(true) }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- /Mail Time & Date -->
                  </div>
                  <!-- MAIL CONTENT -->
                  <div class="vx-row">
                    <div class="output ql-snow">
                      <div class="ql-editor" v-html="currentNotice.detail"></div>
                    </div>
                  </div>
                  <div v-if="currentNotice.service && activeUserLevel >= 2" class="cursor-pointer ml-4" @click="activeCommentPrompt = true; comment=''">
                    <!-- <vs-button type="flat" color="dark" style="padding:5px;">댓글쓰기</vs-button> -->
                      <span style="padding:5px; text-decoration: underline; margin-left:-15px;">댓글쓰기</span>
                  </div>
                </vx-card>
              </div>
            </div>
            <div class="vx-row" style="margin-top: 2.2rem">
              <div class="vx-col w-full"  v-for="(item, index) in studentNoticeComments" v-bind:key="index" style="margin-bottom:10px;">
                <vx-card style="margin-bottom:8px;" v-if="activeUserInfo.uid != item.user_id">
                  <div class="vx-row">
                    <div class="vx-col w-full flex" v-if="item.parents_id != 0">
                      <feather-icon icon="CornerDownRightIcon" svg-classes="h-4 w-4"/>
                      <span class="ml-4">{{getParentText(item.parents_id)}}</span>
                    </div>
                    <div class="vx-col w-full flex">
                      <span class="ml-4">{{item.comment}}</span>
                    </div>
                      <div class="vx-col w-full flex justify-end">
                      <span v-if="activeSpaceInfo.service == true && activeUserLevel >= 2 && activeUserInfo.uid != item.user_id " class="cursor-pointer ml-4" @click="addReply(item.id)">답글</span>
                      <!-- <vs-button color="#000000" icon-pack="feather" icon="icon-edit" type="flat" class="cursor-pointer" v-if="activeSpaceInfo.service == true && activeUserInfo.uid == item.user_id " @click="editComment(item.comment, item.id)"></vs-button> -->
                      <!-- <vs-button color="#000000" icon-pack="feather" icon="icon-trash" type="flat" class="cursor-pointer" v-if="activeSpaceInfo.service == true && activeUserInfo.uid == item.user_id" @click="deleteComment(item.id)"/> -->
                      <!-- <feather-icon icon="EditIcon" svg-classes="h-4 w-4" class="cursor-pointer ml-4" v-if="activeSpaceInfo.service == true && activeUserInfo.uid == item.user_id " @click="editComment(item.comment, item.id)"></feather-icon>
                      <feather-icon icon="TrashIcon" svg-classes="h-4 w-4" class="cursor-pointer ml-4" v-if="activeSpaceInfo.service == true && activeUserInfo.uid == item.user_id" @click="deleteComment(item.id)"/> -->
                    </div>
                  </div>
                </vx-card>

                <vx-card class="bg-primary-gradient" style="margin-bottom:8px;" v-if="activeUserInfo.uid == item.user_id">
                  <div class="vx-row">
                    <div class="vx-col w-full flex" v-if="item.parents_id != 0">
                      <feather-icon icon="CornerDownRightIcon" svg-classes="h-4 w-4"/>
                      <span class="ml-4">{{getParentText(item.parents_id)}}</span>
                    </div>
                    <div class="vx-col w-full flex">
                      <span class="ml-4 text-white">{{item.comment}}</span>
                    </div>
                      <div class="vx-col w-full flex justify-end">
                      <!-- <span v-if="activeSpaceInfo.service == true && activeUserLevel >= 2 && activeUserInfo.uid != item.user_id " class="cursor-pointer ml-4" @click="addReply(item.id)">답글</span> -->
                      <vs-button color="#fff" icon-pack="feather" icon="icon-edit" type="flat" class="cursor-pointer" v-if="activeSpaceInfo.service == true && activeUserInfo.uid == item.user_id " @click="editComment(item.comment, item.id)"></vs-button>
                      <vs-button color="#fff" icon-pack="feather" icon="icon-trash" type="flat" class="cursor-pointer" v-if="activeSpaceInfo.service == true && activeUserInfo.uid == item.user_id" @click="deleteComment(item.id)"/>
                    </div>
                  </div>
                </vx-card>

              </div>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
    <vs-prompt
      class="email-compose"
      title="댓글 쓰기"
      accept-text= "업로드"
      cancel-text= "취소"
      @cancel="clearFields"
      @close="clearFields"
      @accept="createComment"
      :active.sync="activeCommentPrompt">
      <component :is="scrollbarTag" class="scroll-area p-6 mb-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent>
          <vs-textarea counter="500" v-model="comment" />
        </form>
      </component>
    </vs-prompt>
    <vs-prompt
      class="email-compose"
      title="댓글 수정"
      accept-text= "업로드"
      cancel-text= "취소"
      @cancel="clearFields"
      @close="clearFields"
      @accept="updateComment"
      :active.sync="activeCommentPrompt2">
      <component :is="scrollbarTag" class="scroll-area p-6 mb-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent>
          <vs-textarea counter="500" v-model="comment" />
        </form>
      </component>
    </vs-prompt>
    <vs-prompt
      class="email-compose"
      title="답글 쓰기"
      accept-text= "업로드"
      cancel-text= "취소"
      @cancel="clearFields"
      @close="clearFields"
      @accept="createComment2"
      :active.sync="activeCommentPrompt3">
      <component :is="scrollbarTag" class="scroll-area p-6 mb-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent>
          <vs-textarea counter="500" v-model="comment" />
        </form>
      </component>
    </vs-prompt>
    <vs-prompt
      class="email-compose"
      title="글 수정"
      accept-text= "업로드"
      cancel-text= "취소"
      @cancel="clearFields"
      @close="clearFields"
      @accept="updateStudentNotice"
      :active.sync="activePrompt">
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent>
          <!-- <vs-switch color="success" v-model="serviceVal">
            <span slot="on">on</span>
            <span slot="off">off</span>
          </vs-switch> -->
          <vs-input name="title" label-placeholder="제목" v-model="title" class="w-full mb-6" />
          <quill-editor v-model="message" :options="editorOption" style="height:220px;">
            <div id="toolbar" slot="toolbar">
              <button class="ql-bold">Bold</button>
              <button class="ql-italic">Italic</button>
              <select class="ql-size">
                <option value="small"></option>
                <option selected></option>
                <option value="large"></option>
                <option value="huge"></option>
              </select>
              <select class="ql-font">
                <option selected="selected"></option>
                <option value="serif"></option>
                <option value="monospace"></option>
              </select>
              <!-- <button class="ql-video"></button> -->
            </div>
          </quill-editor>
        </form>
      </component>
    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  props: {
    openStudentNoticeId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      comment               : '',
      showThread            : false,
      activePrompt          : false,
      message               : '',
      title                 : '',
      uploadPrompt          : false,
      serviceVal            : false,
      activeCommentPrompt   : false,
      activeCommentPrompt2  : false,
      activeCommentPrompt3  : false,
      replayId              : 0,
      selectCommentId       : 0,
      settings              : {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50,
      },
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        },
      placeholder: '내용을 입력해주세요.'
      },
    }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    },
    openStudentNoticeId(){
      this.$store.commit('studentNotice/SET_ACTIVE_STUDENTNOTICE', this.$store.getters['studentNotice/getStudentNotice'](this.openStudentNoticeId))
      this.$store.dispatch('studentNotice/getStudentNoticeComment', this.openStudentNoticeId)
    },
  },
  computed: {
    activeUserInfo(){
      return this.$store.state.AppActiveUser
    },
    currentNotice(){
      return this.$store.state.studentNotice.ActiveStudentNotice
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    studentNoticeComments() {
      return this.$store.state.studentNotice.studentNoticeComments
    },
  },
  created(){
    this.$store.dispatch('studentNotice/getStudentNoticeComment', this.openStudentNoticeId)
  },
  methods: {
    getParentText(id){
      var parent = this.$store.getters['studentNotice/getComment'](id)
      return parent.comment
    },
    editComment(comment, id){
      this.comment = comment
      this.selectCommentId = id
      this.activeCommentPrompt2 = true
    },
    deleteComment(id){
      this.$store.dispatch('studentNotice/deleteStudentNoticeComment', id).then(()=>{
        this.$vs.notify({
          color: 'success',
          title: '삭제 완료',
        })
      })
    },
    addReply(id){
      this.replayId = id
      this.comment = ''
      this.activeCommentPrompt3 = true
    },
    updateComment(){
      this.$store.dispatch('studentNotice/updateStudentNoticeComment', {id:this.selectCommentId, comment:this.comment})
    },
    createComment(){
      this.$store.dispatch('studentNotice/addStudentNoticeComment', {workspace_id:this.activeSpaceInfo.id ,id:this.openStudentNoticeId, comment:this.comment, parents_id:0})
    },
    createComment2(){
      this.$store.dispatch('studentNotice/addStudentNoticeComment', {workspace_id:this.activeSpaceInfo.id ,id:this.openStudentNoticeId, comment:this.comment, parents_id:this.replayId})
    },
    editStudentNotice() {
      this.title = this.currentNotice.title
      this.message = this.currentNotice.detail
      this.serviceVal = this.currentNotice.service
      this.activePrompt = true
    },
    clearFields() {
      this.$nextTick(() => {
        this.title = ''
        this.message = ''
      })
    },
    moveTo(to) {
      this.$emit('closeSidebar')
      this.$emit('moveTo', to)
    },
    deleteStudentNotice() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `글 삭제`,
        text: '해당 글을 삭제하시겠습니까?',
        accept: this.acceptDelete
      })
    },
    acceptDelete() {
      this.$store.dispatch('studentNotice/deleteStudentNotice', this.openStudentNoticeId)
      .then(()=>{
        this.$emit('closeSidebar')
        this.$vs.notify({
          color: 'success',
          title: '삭제 완료',
          text: '선택된 글이 삭제되었습니다.'
        })
      })
    },
    updateStudentNotice() {
      this.uploadPrompt = true
      this.$store.dispatch('studentNotice/updateStudentNotice', {'id':this.openStudentNoticeId, 'workspace_id':this.activeSpaceInfo.id, 'title':this.title, 'detail':this.message, 'service':this.serviceVal}).then(()=>{
        this.uploadPrompt = false
        this.$vs.notify({
          color: 'success',
          title: '수정 완료'
        })
      }).catch(() => {
        this.uploadPrompt = false
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '관리자에게 문의해 주세요.'
        })
      })
    },
  },
  components: {
    quillEditor,
    VuePerfectScrollbar,
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.filebox label {
  text-align: center;
  width:100%;
  display: inline-block;
  padding: .5em .75em;
  color: #000000;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #E7E7E7;
  cursor: pointer;
  border:  solid #E7E7E7 2px;
  border-radius: .25em;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.filebox label:hover {
  background-color: #ffffff;
  border:  solid #E7E7E7 2px;
}

.filebox label:active {
  background-color: #ffffff;
  border:   solid #E7E7E7 2px;
}

.filebox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
#email-app{
    .vs-sidebar--background{
        position: absolute;
    }
    .select-all-chexkbox{
        .vs-checkbox{
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 6.3%);

      &:not(.ps) {
        overflow-y: auto;
      }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }


    .email__mails {

        .email__mail-item {
            transition: all .35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;


                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0px 3px 10px 0px #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar{
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header{
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all .35s;
        }

        .mail__attachment {
          .vs-chip--text {
            margin-left: 0;
            margin-right: 0;
          }
        }
    }
}


// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 730px;
        // max-height: 95vh;

        .vs-dialog-text {
            padding: 0;

            .scroll-area {
                max-height: 75vh;

                &:not(.ps) {
                  overflow-y: auto;
                }
            }

            .compose-mail-attachment {
              .con-input-upload {
                margin: 0;
              }
            }
        }
    }

    .con-img-upload {

    .con-input-upload {
      height: 2.5rem;
      width: 100%;
    }

        .img-upload {
            // height: 4rem;
            margin: 0;
            margin-bottom: .5rem;
            margin-right: 1.5rem;
        }
    }

    .quill-editor {
        margin-bottom: 1.5rem
    }

    .ql-editor {
        height: 150px;
    }
}


</style>
